import { Transforms, Editor, Range } from 'slate';
import { ReactEditor } from 'slate-react';

import { MENTION_DEFINITIONS } from '@xing-com/content-editor-plugin-helpers';

import type { MentionUser } from './types';

// @ts-expect-error Leftover after Brewery migration
const withMentions = (editor) => {
  const { isInline, isVoid } = editor;

  // @ts-expect-error Leftover after Brewery migration
  editor.isInline = (element) => {
    return element.type === MENTION_DEFINITIONS.type ? true : isInline(element);
  };

  // @ts-expect-error Leftover after Brewery migration
  editor.isVoid = (element) => {
    return element.type === MENTION_DEFINITIONS.type ? true : isVoid(element);
  };

  return editor;
};

const insertMention = (editor: ReactEditor, contact: MentionUser) => {
  const mention = {
    children: [{ text: `@${contact.displayName}` }],
    data: { userId: contact.userId },
    mention: true,
    type: 'mention',
  };

  // inserts mention node in the editor and moves cursor after that node
  Transforms.insertNodes(editor, mention);
  Transforms.move(editor);

  // focuses the editor, so that the user can carry on writing
  ReactEditor.focus(editor);

  // Adds an extra space after the mention
  // Required, in order to break out of the mention node
  Transforms.insertNodes(editor, { text: ' ' });
};

// @ts-expect-error Leftover after Brewery migration
const getMentionsCount = (messageArticleV1) => {
  let count = 0;

  if (Array.isArray(messageArticleV1)) {
    messageArticleV1.forEach((block) => {
      Object.keys(block).forEach((articleKey) => {
        if (
          block[articleKey]?.markups &&
          Array.isArray(block[articleKey].markups)
        )
          // @ts-expect-error Leftover after Brewery migration
          count += block[articleKey].markups.filter((markup) =>
            Object.prototype.hasOwnProperty.call(markup, 'mention')
          ).length;
      });
    });
  }

  return count;
};

const getTextAfterSymbol = (editor: ReactEditor) => {
  if (editor.selection && Range.isCollapsed(editor.selection)) {
    const [start] = Range.edges(editor.selection);
    const selectionString = (Editor.first(editor, start)[0] as any).text;
    const lastMentionInSelection = selectionString.slice(
      selectionString.lastIndexOf('@'),
      start.offset
    );
    const usernameLength = lastMentionInSelection.length - 1;
    const usernamePath = Editor.before(editor, start, {
      distance: usernameLength,
    });
    const mentionPath = usernamePath && Editor.before(editor, usernamePath);
    const mentionRange =
      mentionPath && Editor.range(editor, mentionPath, start);

    // When the "@" is not the first symbol of a paragraph
    // gets the mention's text + 1 character before the '@'
    if (mentionRange?.anchor?.offset) mentionRange.anchor.offset -= 1;

    const mentionText = mentionRange && Editor.string(editor, mentionRange);

    // If the queried text matches the regex rules
    const beforeMatch = mentionText?.match(/^\s?@((?:\S*?\s){0,1}\S*?)$/);

    if (beforeMatch) {
      if (
        mentionRange?.anchor.offset !== undefined &&
        // checks if the '@' is not at the beginning of the paragraph
        mentionText !== mentionText?.trimLeft()
      )
        // removes the character before the '@'
        mentionRange.anchor.offset += 1;

      return { range: mentionRange, query: beforeMatch[1] };
    }
  }

  return {};
};

export { withMentions, insertMention, getTextAfterSymbol, getMentionsCount };
